{
  "label": "equipo",
  "name": "Nombre",
  "model": "Gama",
  "type": "Tipo",
  "serialNumber": "Número de serie",
  "sector": "Red",
  "connectivity": "Conectividad",
  "certificate": "Certificado",
  "state": "Estado",
  "states": {
    "activated": "Activado",
    "deactivated": "Desactivado",
    "registered": "Nuevo"
  },
  "actions": {
    "scheduled": {
      "title": "¿Acciones en curso?",
      "yes": "Sí",
      "no": "No",
      "error": "Indeterminado"
    }
  },
  "firmwareVersion": "Versión de software",
  "hardwareVersion": "Versión de hardware",
  "updateCertificate": "Actualización del certificado",
  "updateFirmware": "Actualización del firmware",
  "updateState": {
    "activate": {
      "title": "Activar",
      "execute": "Activar el equipo",
      "description": "Se va a activar el equipo {name}."
    },
    "deactivate": {
      "title": "Desactivar",
      "execute": "Desactivar el equipo",
      "description": "Se va a desactivar el equipo {name}.",
      "warning": "Un equipo desactivado ya no se beneficia de actualizaciones manuales y automáticas de los certificados.",
      "error": "Este equipo no puede desactivarse, ya que hay una operación planificado o en curso."
    }
  },
  "month": "{n} mes | {n} meses",
  "year": "{n} año | {n} años",
  "custom": "Personalizado",
  "dateFormat": "DD/MM/YYYY HH:mm",
  "empty": "No se encontró ningún equipo",
  "delete": {
    "execute": "Eliminar el equipo",
    "description": "Se va a eliminar el equipo {name}.",
    "warning": "Las operaciones asociadas al equipo también se eliminarán.",
    "error": "Este equipo no puede eliminarse, ya que hay una operación planificado o en curso."
  },
  "description": {
    "title": "Descripción",
    "idCard": "DNI",
    "state": "Estado",
    "connectivity": "Conectividad",
    "lastConnection": "Última conexión",
    "certificateValidityDate": "Fecha de validez del certificado",
    "lastChange": "Último cambio",
    "configurationApplicationDate": "Fecha de aplicación de la configuración",
    "lastRebootDate": "Fecha del último reinicio",
    "firstCommissioningDate": "Fecha de la primera puesta en servicio",
    "lastFirmwareUpdate": "Última actualización del firmware",
    "mobileNetwork": "Red móvil",
    "gsmFrequencyBand": "Banda de frecuencia GSM",
    "communicationProtocol": "Protocolo de comunicación"
  },
  "certificateForm": {
    "expirationDate": "Fecha de caducidad del certificado",
    "certificateOrigin": "Origen del certificado",
    "lastUpdate": "Última actualización del certificado"
  },
  "firmwareForm": {
    "title": "Firmware",
    "version": "Versión",
    "description": "Descripción del firmware",
    "origin": "Origen del firmware",
    "lastUpdate": "Última actualización"
  },
  "configurationForm": {
    "title": "Configuración"
  },
  "operation": {
    "cancel": {
      "tooltip": {
        "enabled": "Anular la operación",
        "disabled": "Ya no puede anular la operación"
      },
      "confirm": {
        "title": "Anulación de la operación",
        "description": "Esta operación se anulará. Esta acción es reversible."
      }
    },
    "unitary": "Unitarios",
    "campaign": "Campañas",
    "update": {
      "tooltip": {
        "enabled": "Actualizar la operación",
        "disabled": "No puede modificar la operación"
      }
    }
  },
  "additionalMetadata": {
    "title": "Metadatos adicionales",
    "options": {
      "title": "Opciones",
      "software": {
        "1": "Automatismo",
        "2": "Estación de bombeo",
        "3": "Servidor Web",
        "4": "Sinópticos web",
        "5": "IP de seguridad ADSL/GSM",
        "6": "IEC60870-5-104 Slave"
      },
      "numericSoftware": {
        "1": "N° de informaciones: {value}",
        "2": "Número de módulos I/O: {value}",
        "3": "Número de módulos COM: {value}"
      }
    },
    "communicationModules": {
      "title": "Módulos de comunicación"
    },
    "modulesIo": {
      "title": "Módulos I/O"
    },
    "modules": {
      "location": "Posición",
      "module": "Módulos"
    }
  },
  "warningMessage": "El equipo ya tiene una operación del mismo tipo planificada o en curso"
}
